// extracted by mini-css-extract-plugin
export default {"section":"Faq_section__WE3Tp","content":"Faq_content__OGJq5","description":"Faq_description__SZQAZ","chevron":"Faq_chevron__Qxj5N","chevron-active":"Faq_chevron-active__AcTlq"};